module.exports = __webpack_public_path__ + "officeMoving-da5e8a82.svg";